const initialState = {
  fetching: false,
};

export default function dataReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'INITIATE':
      return { ...currentState, fetching: true };
    case 'SUCCESS':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
